// Each favorite has this structure, to make it backwards compatible
// {
//   "id": 4477,
//   "title": "Programmeur Java",
//   "organization": "JRPL",
//   "vacancySlug": "programmeur-java",
//   "companySlug": "jrpl"
// }
export const getFavorites = () => {
  const favorites = []

  const userDataStr = localStorage.getItem('user')
  if (userDataStr) {
    const data = JSON.parse(userDataStr)
    return data?.user?.favorites || []
  }

  return favorites
}

export const saveFavorites = (favorites) => {
  let data = { user: {} }
  const userDataStr = localStorage.getItem('user')
  if (userDataStr) {
    data = JSON.parse(userDataStr)
    if (!data.user) {
      data.user = {}
    }
  }
  data.user.favorites = favorites
  localStorage.setItem('user', JSON.stringify(data))
}

// Each saved search has this structure, to make it backwards compatible
// {
//   search_term: 'Gedragswetenschapper',
//   location: 'Amersfoort (Stad)',
//   latitude: 52.1562499,
//   longitude: 5.3896944,
//   distance: 5,
// }
export const getSavedSearches = () => {
  const savedSearches = []

  const userDataStr = localStorage.getItem('user')
  if (userDataStr) {
    const data = JSON.parse(userDataStr)
    return data?.user?.recent_search || []
  }

  return savedSearches
}

export const saveSearches = (searches) => {
  let data = { user: {} }
  const userDataStr = localStorage.getItem('user')
  if (userDataStr) {
    data = JSON.parse(userDataStr)
    if (!data.user) {
      data.user = {}
    }
  }
  data.user.recent_search = searches
  localStorage.setItem('user', JSON.stringify(data))
}

const knownMetadataFields = ['campaign', 'source', 'medium', 'term', 'content']
export const getMetadata = (siteSlug) => {
  const metadata = {
    firstTouchUtm: {},
    lastTouchUtm: {},
  }

  metadata.page = {
    title: document.title,
    url: window.location.toString(),
    slug: siteSlug,
  }

  // Read metadata cookies
  document.cookie.split('; ').forEach((cookieRow) => {
    const [cookieName, cookieValue] = cookieRow.split('=')

    const firstTouchCookie = cookieName.startsWith('__ft_')
    const lastTouchCookie = cookieName.startsWith('__lt_')
    if (firstTouchCookie || lastTouchCookie) {
      const propName = cookieName.split('_').slice(-1)[0]
      if (propName === 'referrer' && firstTouchCookie) {
        metadata.referrer = cookieValue
      } else if (knownMetadataFields.includes(propName)) {
        if (firstTouchCookie) {
          metadata.firstTouchUtm[propName] = cookieValue
        } else {
          metadata.lastTouchUtm[propName] = cookieValue
        }
      }
    }
  })

  return metadata
}
